import { makeStyles } from '@material-ui/core/styles';

export const useMotiveMobileStyles = makeStyles(() => ({
  title: {
    fontSize: 14,
    fontWeight: 600,
  },
  link: {
    textDecoration: 'none',
    color: 'black',
    width: '100%',
  },
  boxMotive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #BCBCBC',
    width: '100%',
  },
}));

export const useMotiveTitleStyles = makeStyles(() => ({
  box: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    justifyContent: 'center',
  },
  title: {
    fontSize: (props) => (props.mobile ? 18 : 22),
    fontWeight: 600,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#464646',
    textAlign: 'center',
    fontWeight: 600,
    marginBottom: 30,
  },
  icon: {
    width: 50,
    height: 70,
    marginRight: 10,
  },
}));
